import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDQva2l_m1BoZ5EB-NhOlvo-EWCgxjSBnA",
    libraries: "places",
  },
});
